// Sales rule (merchant 04/11/2026): up to 5 units of a model per order, above that a volume quote (/pages/bulk-order).
// The quantity selectors already stop at the limit (snippets/oms-order-limit). This module covers what they cannot see:
// a card "Add to cart" button clicked several times and carts filled before the rule. Keep LIMIT and TYPES in sync with
// the snippet. It is a storefront rule: server-side checkout validation needs a Shopify Function in a custom app (Plus
// plan only), and an order above the limit placed some other way simply pays the full price.
const LIMIT = 5;
const TYPES = new Set(['ASIC Miner', 'ASIC Spare Part']);
let running = false;
let again = false;

async function enforce() {
  if (running) {
    again = true;
    return;
  }
  running = true;
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    const component = document.querySelector('cart-items-component');
    let reload = false;
    for (const [index, item] of cart.items.entries()) {
      if (!TYPES.has(item.product_type) || item.quantity <= LIMIT) continue;
      const line = index + 1;
      if (component?.updateQuantity) {
        await component.updateQuantity({ line, quantity: LIMIT, action: 'change' });
      } else {
        await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity: LIMIT }),
        });
        reload = true;
      }
    }
    if (reload) window.location.reload();
  } catch (error) {
    console.warn('oms-order-limit', error);
  } finally {
    running = false;
    if (again) {
      again = false;
      enforce();
    }
  }
}

document.addEventListener('shopify:cart:lines-update', (event) => {
  Promise.resolve(event.promise).then(enforce, () => {});
});
if (document.querySelector('script[data-oms-check-cart]')) enforce();
